<template>
<v-col class="pa-0 ma-0 py-0 my-0" cols="12" md="12" sm="12">{{ GetEjecucion }}
 <!-- v-toolbar accion  -->
<v-toolbar dark color="#dd4b39" dense>

<v-tooltip bottom>
  <template v-slot:activator="{ on }">

    <v-toolbar-title v-on="on"> <i style="font-size: 20px;" class="fa fa-info-circle"> </i> Datos Del Pagare
    </v-toolbar-title>

  </template>
  <i style="font-size: 20px;" dark dense class="fa fa-info-circle"> <span>Datos Del Pagare: </span> Ver Pagare</i>

</v-tooltip>

<v-spacer></v-spacer>

<v-card-actions>
  <v-tooltip bottom>
    
    <template v-slot:activator="{ on }"> 
      <v-btn id="boton-mini" v-on="on" @click=" cancelarfacturaPagare()"
        color="orange" small dark>
        <i style="font-size: 20px;" class="fa fa-reply-all"> </i>
        CANCELAR
      </v-btn>
    </template>
    <span>CANCELAR: Cancela y retornar atrás</span>
  </v-tooltip>

<div v-show="ObjTemPagare!=null">
<v-tooltip bottom >
                <template v-slot:activator="{ on }">
                  <v-btn id="boton-mini" v-on="on" @click="newDtosPagareFactura()" color="grey" small dark>

                    <v-avatar tile size="28" color="transparent">
                      <img src="@/assets/icons_pv/extras/limpiarPantalla.png" alt="Limpiar">
                    </v-avatar>


                    <i style="font-size: 20px;"> </i>
                    NUEVO
                  </v-btn>
                </template>
                <span>NUEVO: Limpia los campo para un nuevo registro</span>
 </v-tooltip>
</div>


  <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn id="boton-mini" v-on="on" @click="SalvarDatosPagareFactura" color="light-blue darken-4" small
                    dark>
                    <i style="font-size: 20px;" class="fa fa-plus"></i><!-- fab x-small dark  -->
                    SALVAR
                  </v-btn>
                </template>
         <span>SALVAR: Guardar pagares y retornar atrás </span>
</v-tooltip>





</v-card-actions>

</v-toolbar>
<!-- v-toolbar  accion -->
<v-col cols="12" md="12" sm="12">
          <v-card color="grey lighten-3">
            <v-col cols="12" md="12" sm="12" class="pa-0 ma-0 py-0 my-0">
              <!-- Infomacion Selecionada -->
              <v-row v-if="clienteFactura != null">
                <v-col cols="12" md="6" sm="6">
                  <p style="border: 1px dashed  #616161;" class="pa-0 ma-0 py-0 my-0"><b> CÓDIGO #: </b>
                    {{ clienteFactura.codigo }}</p>
                  <p style="border: 1px dashed  #616161;" class="pa-0 ma-0 py-0 my-0"><b> CLIENTE: </b>
                    {{ clienteFactura.nombre }}</p>
                  <p style="border: 1px dashed  #616161;" class="pa-0 ma-0 py-0 my-0"><b> TELEFONO : </b>
                    {{ clienteFactura.telefono1 }}</p>
                </v-col>
                <v-col cols="12" md="6" sm="6">
                  <p style="border: 1px dashed  #616161;" class="pa-0 ma-0 py-0 my-0"><b> DIRECCIÓN: </b>
                    {{ clienteFactura.direccion }}</p>
                  <p style="border: 1px dashed  #616161;" class="pa-0 ma-0 py-0 my-0"><b> FECHA : </b>
                    {{ FormatoFecha(fechaFactura) }}</p>
                  <p style="border: 1px dashed  #616161;" class="pa-0 ma-0 py-0 my-0"><b> TOTAL FACTURA: </b>
                    {{ currencyFormatter2(totalGeneral_total) }}</p>
                </v-col>
              </v-row>
              <!-- fn Infomacion Selecionada -->

              <!--  Tabla  -->
              <div>
                <v-data-table class="RowSelectColor" item-key="indx" :headers="[
                  { text: 'Código', sortable: false, value: 'productos.codigo', width: 120, class: ['no-gutters  black--text'] },
                  { text: 'Descripción', sortable: false, value: 'productos.descripcion', width: 'auto', class: ['no-gutters  black--text'] },
                  { text: 'Cantidad', sortable: false, value: 'cantidad', width: 129, class: ['no-gutters  black--text'] },
                  { text: 'Precio', sortable: false, value: 'precio', width: 'auto', width: 105, class: ['no-gutters  black--text'] },
                  { text: 'Total', sortable: false, value: 'valor', width: 'auto', width: 105, class: ['no-gutters  black--text'] },
                ]" dense :items="RProductoCompra" :footer-props="arrayPropiedases" :items-per-page="20" >

                  <template v-slot:item.productos.codigo="props">
                    <span style="font-size:13px;">{{ props.item.productos.codigo }}</span>
                  </template>

                  <template v-slot:item.productos.descripcion="props">
                    <span style="font-size:13px;">{{ props.item.productos.descripcion }} </span>
                  </template>

                  <template v-slot:item.cantidad="props">
                    <span style="font-size:13px;">{{ props.item.cantidad }} </span>
                  </template>

                  <template v-slot:item.precio="props">
                    <span style="font-size:13px;">{{ currencyFormatter2(props.item.precio) }}</span>
                  </template>

                  <template v-slot:item.valor="props">
                    <span style="font-size:13px;">{{ currencyFormatter2(props.item.valor) }}</span>
                  </template>

                </v-data-table>
              </div>
              <!-- fn Tabla  -->
            </v-col>
          </v-card>

          <!-- Row contrato y cuenta-->
          <v-form ref="formPagares" v-model="valid" lazy-validation>
            <v-row>
              <!--Columna 1  -->
              <v-col cols="12" md="6" sm="6">
                <h3 class="d-flex justify-center">Detalle del contrato</h3>

                <v-row>
                  <v-col cols="12" md="6" sm="6">
                    <!------ Fecha -->
                    <v-text-field dense outlined type="date" label="Fecha inicial:" style="font-size:13px;"
                      v-model="DatosPagareFactura.contrato.fecha" :rules="[$rules.required]" @blur="BlurDesdePagare">

                      <template v-slot:prepend>
                        <i style="font-size: 20px;" class="fa fa-calendar"></i>
                      </template>
                    </v-text-field>
                    <!------ valor prestamo -->
                    <VueAutonumeric id="formdisabledInput" label="Valor del prestamo:" dense outlined autocomplete="off"
                      v-model.number="DatosPagareFactura.contrato.valorPrestamo" disabled style="font-size: 13px;">
                      <template v-slot:prepend>
                        <i style="font-size: 20px;" class="fa fa-money"></i>
                      </template>
                    </VueAutonumeric>
                    <!------ inicio -->
                    <VueAutonumeric id="formdisabledInput" label="Inicio:" autocomplete="off" dense outlined
                      v-model.number="DatosPagareFactura.contrato.inicio" @input="calcularCapital" @blur="cargarDetallePagare">
                      <template v-slot:prepend>
                        <i style="font-size: 20px;" class="fa fa-italic"></i>
                      </template>
                      <template v-slot:append-outer>
                        <v-tooltip top>
                                  <template v-slot:activator="{ on }">

                                    <v-btn @click.prevent="openDialogBuscarPago" v-on="on" color="blue darken-3" fab
                                      x-small dark>
                                      <i style="font-size: 20px;" class="fa fa-search"></i>
                                    </v-btn>

                                  </template>
                                  <span>Buscar Pago</span>
                                </v-tooltip>
                      </template>
                    </VueAutonumeric>
                    <!------ inicio -->

                    <!------ Valor Recibido: -->
                    <VueAutonumeric id="formdisabledInput" label="Valor Recibido:" dense outlined autocomplete="off"
                      v-model.number="DatosPagareFactura.contrato.valorRecibido" disabled style="font-size: 13px;">
                      <template v-slot:prepend>
                        <i style="font-size: 20px;" class="fa fa-money"></i>
                      </template>
                    </VueAutonumeric>

                    <!------ Capital Financiado: -->
                    <VueAutonumeric id="formdisabledInput" label="Capital Financiado:" dense outlined autocomplete="off"
                      v-model.number="DatosPagareFactura.contrato.CapitalFinanciado" style="font-size: 13px;"
                      :rules="[$rules.required]">
                      <template v-slot:prepend>
                        <i style="font-size: 20px;" class="fa fa-money"></i>
                      </template>
                    </VueAutonumeric>


                    <!------ % de Interes: -->
                    <VueAutonumeric id="formdisabledInput" label="% de Interes(Ganado):" dense outlined autocomplete="off"
                      v-model.number="DatosPagareFactura.contrato.interes" style="font-size: 13px;" @blur="cargarDetallePagare">
                      <template v-slot:prepend>
                        <i style="font-size: 20px;" class="fa fa-percent"></i>
                      </template>
                    </VueAutonumeric>

                    <!------ Cantidad Cuotas: -->
                    <VueAutonumeric id="formdisabledInput" label="Cantidad Cuotas:" dense outlined autocomplete="off"
                      v-model.number="DatosPagareFactura.contrato.CantidadCuotas" @input="calcularInteres"  @blur="cargarDetallePagare"
                      style="font-size: 13px;" :rules="[$rules.required]">
                      <template v-slot:prepend>
                        <i style="font-size: 20px;" class="fa fa-sort-numeric-asc"></i>
                      </template>
                    </VueAutonumeric>


                  </v-col>

                  <!----------------------------------------  -->
                  <v-col cols="12" md="6" sm="6">

                    <!------ Capital a pagar: -->
                    <VueAutonumeric id="formdisabledInput" label="Capital a pagar:" dense outlined disabled
                      autocomplete="off" v-model.number="DatosPagareFactura.contrato.Capitalpagar"
                      style="font-size: 13px;">
                      <template v-slot:prepend>
                        <i style="font-size: 20px;" class="fa fa-money"></i>
                      </template>
                    </VueAutonumeric>

                    <!------ Interes a pagar: -->
                    <VueAutonumeric id="formdisabledInput" label="Interes a pagar:" dense outlined autocomplete="off"
                      v-model.number="DatosPagareFactura.contrato.Interespagar" style="font-size: 13px;" disabled>
                      <template v-slot:prepend>
                        <i style="font-size: 20px;" class="fa fa-percent"></i>
                      </template>
                    </VueAutonumeric>

                    <!------ Monto Cuotas -->
                    <VueAutonumeric id="formdisabledInput" label="Monto Cuotas:" dense outlined autocomplete="off"
                      v-model.number="DatosPagareFactura.contrato.MontoCuotas" style="font-size: 13px;" disabled>
                      <template v-slot:prepend>
                        <i style="font-size: 20px;" class="fa fa-money"></i>
                      </template>
                    </VueAutonumeric>

                    <!-- Tipo Interes -->
                    <v-combobox id="formdisabledInput" autocomplete="off" dense outlined label="Tipo Interes:"
                      :items="RTipoInteres" item-text="descripcion" style="font-size: 13px;"
                      v-model="DatosPagareFactura.contrato.TipoInteres" @change="cargarDetallePagare"
                      :rules="[$rules.required]">
                      <template v-slot:prepend>
                        <i style="font-size: 20px;" class="fa fa-tags"></i>
                      </template>
                    </v-combobox>

                    <!------ Intervalos de días: -->
                    <v-text-field id="formdisabledInput" label="Intervalos de días:" autocomplete="off" dense outlined
                      disabled v-model="DatosPagareFactura.contrato.Intervalosdias">
                      <template v-slot:prepend>
                        <i style="font-size: 20px;" class="fa fa-sun-o"></i>
                      </template>
                    </v-text-field>

                    <VueAutonumeric id="formdisabledInput" label="% Interes Mora:" dense outlined autocomplete="off"
                      v-model.number="DatosPagareFactura.contrato.InteresMora" style="font-size: 13px;">
                      <template v-slot:prepend>
                        <i style="font-size: 20px;" class="fa fa-percent"></i>
                      </template>
                    </VueAutonumeric>

                      <v-text-field id="formdisabledInput" label="Prórroga:" dense outlined type="number" hide-details @keyup="KeyUpCantidad"
                            v-model.number="DatosPagareFactura.contrato.prorroga" :rules="[$rules.Numericc]">
                            <template v-slot:prepend>
                             <i style="font-size: 20px;" class="fa fa-sun-o"></i>
                            </template>

                            <template v-slot:append-outer>
                              <b style="font-size:13px;"> DIA </b>
                            </template>
                          </v-text-field>
                  


                  </v-col>



                </v-row>

              </v-col>
              <!-- fn Columna 1  -->



              <!--Columna 2  -->
              <v-col cols="12" md="6" sm="6">
                <h3 class="d-flex justify-center">Distribución de cuotas</h3>
                <!--  Tabla  -->


                <div>
                  <v-data-table class="RowSelectColor" item-key="indx" :headers="[
                    { text: 'Tipo', sortable: false, value: 'tipo', width: 100, class: ['no-gutters  black--text'] },
                    { text: 'Pago #', sortable: false, value: 'pago', width: 120, class: ['no-gutters  black--text'] },
                    { text: 'Fecha Venc.', sortable: false, value: 'fechaVencimiento', width: 129, class: ['no-gutters  black--text'] },
                    { text: 'Capital', sortable: false, value: 'capital', width: 'auto', width: 105, class: ['no-gutters  black--text'] },
                    { text: 'Interes', sortable: false, value: 'interes', width: 'auto', width: 105, class: ['no-gutters  black--text'] },
                    { text: 'Total', sortable: false, value: 'total', width: 'auto', width: 105, class: ['no-gutters  black--text'] },
                  ]" dense :items="DatosPagareFactura.pagareDetalleList" :footer-props="arrayPropiedases" :items-per-page="20">

                    <template v-slot:item.tipo="props">
                      <span style="font-size:13px; display:none;">{{ props.item.indx =
                      DatosPagareFactura.pagareDetalleList.indexOf(props.item)
                      }}</span>
                      <span style="font-size:13px;">{{ props.item.tipo }}</span>
                    </template>

                    <template v-slot:item.pago="props">
                      <span style="font-size:13px;">{{ props.item.pago }} </span>
                    </template>

                    <template v-slot:item.fechaVencimiento="props">
                      <span style="font-size:13px;">{{ FormatoFecha(props.item.fechaVencimiento) }} </span>
                    </template>

                    <template v-slot:item.capital="props">
                      <span style="font-size:13px;">{{ currencyFormatter(props.item.capital) }}</span>
                    </template>

                    <template v-slot:item.interes="props">
                      <span style="font-size:13px;">{{ currencyFormatter(props.item.interes) }}</span>
                    </template>

                    <template v-slot:item.total="props">
                      <span style="font-size:13px;">{{ currencyFormatter(props.item.total) }}</span>
                      <!-- <span style="font-size:13px;" >{{ currencyFormatter(props.item.total) }}</span> -->
                    </template>

                  </v-data-table>
                </div>
                <!-- fn Tabla  -->
              </v-col>
              <!-- fn Columna 2  -->
            </v-row>
          </v-form>
          <!-- fn Row contrato y cuenta -->



        </v-col>




<!-- Modal Alerta -->
<v-snackbar v-model="aalert.estado" :color="aalert.color" style="margin-top: 20%;" :vertical="true"
          :timeout="120000" top="top">
          {{ aalert.nombre }}

          <v-btn dark text @click="aalert.estado = false">Close</v-btn>
        </v-snackbar>
</v-col>
</template>
<script>
import { EventBus } from "../../event-bus";
import { currencyFormatter, FormatoFecha, HoraFormatter,RedondeoValorCantRed,currencyFormatterCant,fechaNueva,getParamFecha } from "@/js/Funciones.js";
import VueAutonumeric from "../../components/AutoNumericNuevo";
export default {
  components: {
    VueAutonumeric
  },
  created() { 

  },
  mounted() {
   this.metodoInsoluto=this.$store.getters.GetConfiguracionGeneral.configPv.pagoPagareContratoInsoluto
  },
  beforeDestroy() {

  },

  data: () => ({ 
    metodoInsoluto:false,
    arrayPropiedases: {
      'items-per-page-options': [10, 15, 20, 50],
      'items-per-page-text': 'Cantidad de Registros Por Paginas',
      showFirstLastPage: false
    },
    windowSize: { width: "auto", height: "auto" },
    valid: true,
    RProductoCompra:[],
    RTipoInteres: [
      { codigo: 1, descripcion: "Dia", dia: 1, tipo: 1 },
      { codigo: 2, descripcion: "semanal", dia: 7, tipo: 1 },
      { codigo: 3, descripcion: "Quincenal", dia: 15, tipo: 1 },
      { codigo: 4, descripcion: "Mensual", dia: 30, tipo: 2 },
      { codigo: 5, descripcion: "Anual", dia: 365, tipo: 3 },
    ],
    pagoAnticipado:false,

    fechaFactura:fechaNueva(),
    totalGeneral_total:0,

    Monedafactura:null,
    TasaMoneda:1,
    ObjTemPagare: null,
    DatosPagareFactura: {
      contrato: {
        fecha: fechaNueva(),
        valorPrestamo: 3760.35,
        inicio: 0,
        valorRecibido: 0,
        CapitalFinanciado: 0,
        interes: 0,
        CantidadCuotas: 0,
        Capitalpagar: 0,
        Interespagar: 0,
        MontoCuotas: 0,
        TipoInteres: null,
        Intervalosdias: null,
        InteresMora: 0,
        prorroga: 0
      },
      pagoAnticipado:false,
      pagareDetalleList: [],
    },



    aalert: {
        estado: false,
        color: null
      },

  }),
  props: {
    cajaSelect: {
      required: false,
      type: Object,
      default: null
    },

    configuraciones: {
      required: false,
      type: Object,
      default: null
    },
    clienteFactura: {
      required: false,
      type: Object,
      default: null
    },
    
    
  },
  methods: { 
    currencyFormatter, FormatoFecha, HoraFormatter,RedondeoValorCantRed,currencyFormatterCant,fechaNueva,getParamFecha,
     
    SalvarDatosPagareFactura() {

      if (this.$refs.formPagares.validate()) {

        if(this.DatosPagareFactura.pagareDetalleList.length==0){
        this.alerta("debe generar una Distribución de cuotas", "error");
        return
      }

        this.$emit("DataRetornfacturaPagare", this.DatosPagareFactura)

        var _this=this;
    setTimeout(function(){ 
      _this.cancelarfacturaPagare()
     }, 300);   
       

      } else {
        this.alerta("los campos en rojo son requeridos", "error");
      }

    },


    calcularCapital() {
  this.DatosPagareFactura.contrato.CapitalFinanciado = this.DatosPagareFactura.contrato.valorPrestamo - this.DatosPagareFactura.contrato.inicio;
this.DatosPagareFactura.contrato.Capitalpagar = this.DatosPagareFactura.contrato.CapitalFinanciado;

    },

    calcularInteres() {

if(this.metodoInsoluto==true){
 /* //const i = tasaAnual / 12 / 100; // Convertir tasa anual a mensual en decimal
    //const n = numeroPeriodos; // 24 meses
    //const P = montoPrestamo; préstamo de 100,000
    //(P * i) / (1 - Math.pow(1 + i, -n));
    // PAGOS MENSUALES=(2271240 * (12/12/100)) / (1 - Math.pow(1 + (12/12/100), -72)); = 44403.179219830155*/
  if(this.DatosPagareFactura.contrato.interes==0){ this.DatosPagareFactura.contrato.interes=1}

 const montoPrestamo= this.DatosPagareFactura.contrato.CapitalFinanciado;
 const tasaAnual=(this.DatosPagareFactura.contrato.interes/12/100)
 const numeroPeriodos = this.DatosPagareFactura.contrato.CantidadCuotas ;   
this.DatosPagareFactura.contrato.MontoCuotas = this.RedondeoValorCantRed(((montoPrestamo * tasaAnual) / (1 - Math.pow(1 + tasaAnual, -numeroPeriodos))),2)

}else{
  this.DatosPagareFactura.contrato.InteresMensual =
        this.DatosPagareFactura.contrato.CapitalFinanciado *
        (this.DatosPagareFactura.contrato.interes / 100);

      this.DatosPagareFactura.contrato.Interespagar =
        this.DatosPagareFactura.contrato.CapitalFinanciado *
        (this.DatosPagareFactura.contrato.interes / 100) *
        this.DatosPagareFactura.contrato.CantidadCuotas;

      this.DatosPagareFactura.contrato.MontoCuotas =
        this.DatosPagareFactura.contrato.CapitalFinanciado /
        this.DatosPagareFactura.contrato.CantidadCuotas +
        this.DatosPagareFactura.contrato.CapitalFinanciado *
        (this.DatosPagareFactura.contrato.interes / 100);
}


      

    },

   

    detallePagare() {
if(this.metodoInsoluto=true){
this.postdetallePagareInsoluto()
}else{
  this.postdetallePagare()
}
   
    },

     postdetallePagare(){

      //this.Facturasventa.recetaObj.fecha=this.RecetaProdControlado.fecha.trim().substr(0,10)+"T04:00"
      var fecha = this.DatosPagareFactura.contrato.fecha;
      this.DatosPagareFactura.pagareDetalleList = [];

      var d = {
        codigo:0,
        tipo: "PAG",
        pago: "INICIAL",
        fechaVencimiento: fecha.trim().substr(0,10)+"T04:00",
        fechaPago:this.fechaNueva(),
        capital: this.RedondeoValorCantRed(this.DatosPagareFactura.contrato.inicio,2),
        interes: 0.0,
        interesMoraPorciento: 0.0,
        interesMoraValor: 0.0,
        saldado: true,
        pendiente:0,
        total: this.RedondeoValorCantRed(this.DatosPagareFactura.contrato.inicio,2),
      };
      this.DatosPagareFactura.pagareDetalleList.push(d);
      
      var fech=new Date(this.getParamFecha(this.DatosPagareFactura.contrato.fecha.trim().substr(0,10)+"T04:00"))
      for (var i = 1;i <= this.DatosPagareFactura.contrato.CantidadCuotas;i++) 
      {

       /* fech.setDate(fech.getDate() + this.DatosPagareFactura.contrato.TipoInteres.dia);
        fech =new Date( this.getParamFecha(fech))
        console.log('viendo-klk-->\n',this.getParamFecha(fech))*/
        
        fech =this.sumarFechas(fech,this.DatosPagareFactura.contrato.TipoInteres.codigo,this.DatosPagareFactura.contrato.TipoInteres.dia)
    
        /*fecha = this.sumarFechas22Antes(
          fecha,this.DatosPagareFactura.contrato.TipoInteres.tipo,this.DatosPagareFactura.contrato.TipoInteres.dia
        );*/
       // fecha
        var det = {
          codigo:0,
          tipo: "PAG",
          pago: i + "/" + this.DatosPagareFactura.contrato.CantidadCuotas,
          fechaVencimiento: fech ,//fecha.trim().substr(0,10)+"T04:00",
          capital: this.RedondeoValorCantRed((this.DatosPagareFactura.contrato.MontoCuotas - this.DatosPagareFactura.contrato.InteresMensual),2),
          interes: this.DatosPagareFactura.contrato.InteresMensual,
          interesMoraPorciento: 0,
          interesMoraValor: 0,
          saldado: false,
          pendiente:this.RedondeoValorCantRed(this.DatosPagareFactura.contrato.MontoCuotas,2),
          total: this.RedondeoValorCantRed(this.DatosPagareFactura.contrato.MontoCuotas,2),
        };
        // console.log('Detalle-->',det)
        // fecha = this.sumarFechas(fecha,this.DatosPagareFactura.contrato.TipoInteres.tipo,
        //   this.DatosPagareFactura.contrato.TipoInteres.dia
        // );
        //totalPagare += this.util.roundValor(parseFloat($("#montoCuotas").val()));
        this.DatosPagareFactura.pagareDetalleList.push(det);
      }

    },

     postdetallePagareInsoluto(){


//this.Facturasventa.recetaObj.fecha=this.RecetaProdControlado.fecha.trim().substr(0,10)+"T04:00"
      var fecha = this.DatosPagareFactura.contrato.fecha;
      this.DatosPagareFactura.pagareDetalleList = [];
      var SUM_INTERES=0;

      var d = {
        codigo:0,
        tipo: "PAG",
        pago: "INICIAL",
        fechaVencimiento: fecha.trim().substr(0,10)+"T04:00",
        fechaPago:this.fechaNueva(),
        capital: this.RedondeoValorCantRed(this.DatosPagareFactura.contrato.inicio,2),
        interes: 0.0,
        interesMoraPorciento: 0.0,
        interesMoraValor: 0.0,
        saldado: true,
        pendiente:0,
        total: this.RedondeoValorCantRed(this.DatosPagareFactura.contrato.inicio,2),
      };
      this.DatosPagareFactura.pagareDetalleList.push(d);
      
      var fech=new Date(this.getParamFecha(this.DatosPagareFactura.contrato.fecha.trim().substr(0,10)+"T04:00"))

 /* //const i = tasaAnual / 12 / 100; // Convertir tasa anual a mensual en decimal
    //const n = numeroPeriodos; // 24 meses
    //const P = montoPrestamo; préstamo de 100,000
    //const periodo = 5; 
    //(P * i) / (1 - Math.pow(1 + i, -n));
    // PAGOS MENSUALES=(2271240 * (12/12/100)) / (1 - Math.pow(1 + (12/12/100), -72)); = 44403.179219830155*/
 const montoPrestamo= this.DatosPagareFactura.contrato.CapitalFinanciado;
 const tasaAnual=(this.DatosPagareFactura.contrato.interes/12/100)
 const numeroPeriodos = this.DatosPagareFactura.contrato.CantidadCuotas ; 
 const cuota = this.DatosPagareFactura.contrato.MontoCuotas  //cuota = ((P * i) / (1 - Math.pow(1 + i, -n)));
      for (var i = 1;i <= this.DatosPagareFactura.contrato.CantidadCuotas;i++) 
      {
        fech =this.sumarFechas(fech,this.DatosPagareFactura.contrato.TipoInteres.codigo,this.DatosPagareFactura.contrato.TipoInteres.dia)
    //const saldoPendiente = P * Math.pow(1 + i, periodo - 1) - cuota * ((Math.pow(1 + i, periodo - 1) - 1) / i);
const periodo = i;
const saldoPendiente = this.RedondeoValorCantRed((montoPrestamo * Math.pow(1 + tasaAnual, periodo - 1) - cuota * ((Math.pow(1 + tasaAnual, periodo - 1) - 1) / tasaAnual)),2);
const interes = this.RedondeoValorCantRed(saldoPendiente * tasaAnual,2);

const saldoPendiente2 = this.RedondeoValorCantRed((montoPrestamo * Math.pow(1 + tasaAnual, periodo - 1) - cuota * ((Math.pow(1 + tasaAnual, periodo - 1) - 1) / tasaAnual)),2);
 // Interés del período actual
const interesPeriodo = this.RedondeoValorCantRed(saldoPendiente2 * tasaAnual,2);
// Principal pagado en el período actual
const saldoCapital = cuota - interesPeriodo;



        var det = {
          codigo:0,
          tipo: "PAG",
          pago: i + "/" + this.DatosPagareFactura.contrato.CantidadCuotas,
          fechaVencimiento: fech ,//fecha.trim().substr(0,10)+"T04:00",
          capital: this.RedondeoValorCantRed(saldoCapital,2),
          interes: this.RedondeoValorCantRed(interes,2),
          interesMoraPorciento: 0,
          interesMoraValor: 0,
          saldado: false,
          pendiente:this.RedondeoValorCantRed(this.DatosPagareFactura.contrato.MontoCuotas,2),
          total: this.RedondeoValorCantRed(this.DatosPagareFactura.contrato.MontoCuotas,2),
        };
  
        this.DatosPagareFactura.pagareDetalleList.push(det);

        SUM_INTERES+=this.RedondeoValorCantRed(interes,2)

      }


      this.DatosPagareFactura.contrato.Interespagar=SUM_INTERES;

    },

    





   
    sumarFechas(fecha, CodFrecuencia, CantF){

var fech=new Date(this.getParamFecha(fecha));
//NOTAS://
/*
codigo:1-->descripcion:"Dia"-->dia:1
codigo:2-->descripcion:"semanal"-->dia:7
codigo:3-->descripcion:"Quincenal"-->dia:15
codigo:4-->descripcion:"Mensual"-->dia:30
codigo:5-->descripcion:"Anual"-->dia:365
*/

//aumenta dias
if(CodFrecuencia>=1 && CodFrecuencia<=3){
fech.setDate(fech.getDate() + CantF);
fech =new Date(fech)
}
//aumenta mes
if(CodFrecuencia==4){
fech.setMonth(fech.getMonth() + 1);
fech =new Date(fech)
}
// aumenta year
if(CodFrecuencia==5){
fech.setFullYear(fech.getFullYear() + 1);
fech =new Date(fech)
}

      // fech.setDate(fech.getDate() + this.DatosPagareFactura.contrato.TipoInteres.dia);
      // fech =new Date( getParamFecha(fech))
return this.getParamFecha(fech)
      

    },

    sumarFechas22Antes(fecha, tipo, cantidad) {
      var parts = fecha.split("-");
      var fech;
      if (tipo === 1) {
        fech = new Date(parts[0], parts[1] - 1, parseInt(parts[2]) + cantidad);
      }
      if (tipo === 2) {
        fech = new Date(parts[0], parts[1], parts[2]);
      }
      if (tipo === 3) {
        fech = new Date(parseInt(parts[0]) + 1, parts[1] - 1, parts[2]);
      }
      return fech.toISOString().substring(0, 10);
    },

    cargarDetallePagare() {
      this.calcularCapital()
      // if (this.DatosPagareFactura.contrato.fecha === "") {
      //   this.alerta("Debe Seleccionar Una Fecha", "error");
      // }
      // if (this.DatosPagareFactura.contrato.CantidadCuotas === "") {
      //   this.alerta("Debe seleccionar la cantidad de cuotas ", "error");
      // }
      // this.DatosPagareFactura.contrato.Intervalosdias =
      //   this.DatosPagareFactura.contrato.TipoInteres.dia;
      //  this.detallePagare();
      this.DatosPagareFactura.pagareDetalleList = [];
   
      if (this.DatosPagareFactura.contrato.fecha.toString().length == 0) {
        this.alerta("Debe Seleccionar Una Fecha", "error");
        return
      }
      if (this.DatosPagareFactura.contrato.CantidadCuotas === "") {
        this.alerta("Debe seleccionar la cantidad de cuotas ", "error");
        return
      }
if(this.DatosPagareFactura.contrato.TipoInteres!=null &&this.DatosPagareFactura.contrato.TipoInteres.hasOwnProperty('codigo') ){
  this.DatosPagareFactura.contrato.Intervalosdias =this.DatosPagareFactura.contrato.TipoInteres.dia;
}else{ return}
      

      //  this.detallePagare();
      var _this = this;
      
setTimeout(function () { _this.calcularCapital()
  _this.calcularInteres()
}, 500);
      
      setTimeout(function () { _this.detallePagare() }, 900);

    },



    async ImprimirfacturaPagare(e) {

      if(this.cajaSelect.formatoimpresioncontado.trim().includes('medPag')){
        if (localStorage.printerSelect != null) {
                      var msg = {
                        accion: "print",
                        formato: this.cajaSelect.formatoimpresioncontado.trim(),
                        impresora: JSON.parse(localStorage.printerSelect).nombre,
                        data: this.configuraciones,
                        obj: e,
                        caja: this.cajaSelect,
                      };
                      this.imprimir(msg, "pedidofactura");
                    }
      }else{

        EventBus.$emit("loading", true);
      var headers = this.$store.getters.GetheadersAxios

this.$axios.get(this.$hostname + this.$hName + "/pedidosfacturacion/imprimir/"+e.idpedido, { headers: headers }).then(res => {
  EventBus.$emit("loading", false)
  /*let pdfWindow = window.open("Reporte de imprecion")
  pdfWindow.document.write("<embed width='100%' height='100%' type='application/pdf'   src='data:application/pdf;base64," +
    encodeURI(res.data) + "'></embed>")*/
    var PDF=`data:application/pdf;base64,${encodeURI(res.data)}`;
    EventBus.$emit("openPDF",PDF ,'pedidos facturacion');
})
.catch((error) => {
          this.alerta("Reporte no generado", "error");
          console.log(error)
          EventBus.$emit("loading", false);
        });

      }
      
    },


    async cancelarfacturaPagare() {
      //EventBus.$emit("loading", true);
      //NewDatosPagareFactura:cancelarfacturaPagare

    this.NewDatosPagareFactura()
    var _this=this;
    setTimeout(function(){ 
      _this.$emit("DataRetornCancelarfacturaPagare", false)
     }, 300);
    // this.dialogfacturaPagare = false;
    //   this.dialogPagare = false;
    //   this.DatosPagareFactura = JSON.parse(JSON.stringify(this.ObjTemPagare));
    //   this.ObjTemPagare = null;
    //   var _this=this;
    // setTimeout(function(){ 
    //   _this.$emit("DataRetornCancelarfacturaPagare", false)
    //  }, 300);
    },



    imprimir(datos, operacion) {
      datos.schema = this.$store.getters.GetheadersAxios["X-TENANT-ID"]
      datos.operacion = operacion;
      if (datos.formato === "fiscale") {
        this.$axios.get("http://localhost:15999/impresora/imprimir/validad").then(res => {
          if (res.data.LastError ===0) {
          this.$axios
          .post("http://localhost:15999/impresora/imprimir", datos)
          .then((res) => {
          })
          .catch((error) => console.error(error));
          }else{
            this.alerta("La impresora esta desconectada o esta apagada!!!","error")
            return;
          }
        })
      }else{
        this.$axios
          .post("http://localhost:15999/impresora/imprimir", datos)
          .then((res) => {
            // this.limpiarTodoCompleto();
          })
          .catch((error) => console.error(error));
      }
    },

    BlurDesdePagare(){
    if (this.DatosPagareFactura.contrato.fecha.toString().length == 0) {
      this.DatosPagareFactura.contrato.fecha= this.fechaNueva()
      }


        var _this = this;
              
        setTimeout(function () { 
          _this.cargarDetallePagare()
        }, 500);
    },


    NewDatosPagareFactura() {


      this.fechaFactura=fechaNueva()
      this.totalGeneral_total=0
      this.Monedafactura=null
      this.TasaMoneda=1
      this.ObjTemPagare= null
      this.RProductoCompra=[],
      this.DatosPagareFactura = {
        contrato: {
          fecha: this.fechaNueva(),
          valorPrestamo: 0.0,
          inicio: 0,
          valorRecibido: 0,
          CapitalFinanciado: 0,
          interes: 0,
          CantidadCuotas: 0,
          Capitalpagar: 0,
          Interespagar: 0,
          MontoCuotas: 0,
          TipoInteres: null,
          Intervalosdias: null,
          InteresMora: 0,
          prorroga: 0,
        },

        pagareDetalleList: [],
      };
    },

    newDtosPagareFactura(){


      this.ObjTemPagare= null
      this.DatosPagareFactura = {
        contrato: {
          fecha: this.fechaNueva(),
          valorPrestamo: 0.0,
          inicio: 0,
          valorRecibido: 0,
          CapitalFinanciado: 0,
          interes: 0,
          CantidadCuotas: 0,
          Capitalpagar: 0,
          Interespagar: 0,
          MontoCuotas: 0,
          TipoInteres: null,
          Intervalosdias: null,
          InteresMora: 0,
          prorroga: 0
        },
        pagoAnticipado:false,
        pagareDetalleList: [],
      };

      
  
    var _this=this;
    setTimeout(function(){ 
      _this.$emit("newDtosPagareFactura", false)
      _this.DatosPagareFactura.contrato.valorPrestamo =JSON.parse(JSON.stringify(_this.totalGeneral_total));
     }, 300);   




    },


    openDialogBuscarPago(){
      this.RPagosAnticipado = []
  if (this.clienteFactura==null || !this.clienteFactura.hasOwnProperty('codigo')) {
        this.alerta("Seleccione un cliente", "error");
        return
      }
  //this.form.recibo.valorAnticipado=0
  //this.form.recibo.pagoAnticipadoOtrosIngreso=null
  
  var Obj={
    cliente: this.clienteFactura.codigo
  }


this.$axios
          .post(this.$hostname + this.$hName + "/otrosingresos/findAllRecOtrPagosAnticipado", Obj, {
            headers: this.$store.getters.GetheadersAxios,
          })
          .then((res) => {

            if(res.data.ListItems.length==0){
              this.DatosPagareFactura.pagoAnticipado=false
              this.alerta(`${this.clienteFactura.nombre.trim()}, No posee pagos anticipado`, "error");
            }else{
             // this.dialogBuscarPago = true
             // this.RPagosAnticipado = res.data.ListItems
             if(res.data.sumaTotal>this.DatosPagareFactura.contrato.valorPrestamo){
              //this.pagoAnticipado=true
              this.DatosPagareFactura.pagoAnticipado=true
              this.DatosPagareFactura.contrato.inicio=JSON.parse(JSON.stringify(this.DatosPagareFactura.contrato.valorPrestamo))
             }else{
              if(res.data.sumaTotal>0){
                this.DatosPagareFactura.pagoAnticipado=true
                //this.pagoAnticipado=true
                this.DatosPagareFactura.contrato.inicio=JSON.parse(JSON.stringify(res.data.sumaTotal))
              }else{ this.DatosPagareFactura.pagoAnticipado=false}
              
             }
             

            }
            
          })
          .catch((error) => { 
            this.DatosPagareFactura.pagoAnticipado=false
            console.log('Catch--->',error)


           });

    },


    currencyFormatter2(value) {

/* return (
 "" +
 //parseFloat(this.RedondeoValor(value / this.TasaMoneda)).toLocaleString("en",{ minimumFractionDigits: this.CantRedondeo })
);*/

var MONEDA=JSON.parse(JSON.stringify(this.$store.getters.GetConfiguracionGeneral.config.monedabase))
var MONEDAFACTURA= (this.Monedafactura!=null?this.Monedafactura.tasa:MONEDA.tasa )
var CANTREDONDEO=(MONEDAFACTURA!=MONEDA.tasa?4:2)

return (
 "" +
 parseFloat(this.RedondeoValorCantRed(value / this.TasaMoneda,CANTREDONDEO)).toLocaleString("en",{ minimumFractionDigits: CANTREDONDEO })
);


},

KeyUpCantidad(e) {
      if (e.target.value.length == 0) {
        e.target.value = 0;
      }
      if (e.key) {
        var mynumeral = require("numeral");
        e.target.value = mynumeral(e.target.value).value();
        if (e.target.value == null) {
          e.target.value = 0;
        }
      } else {
        e.key = "";
      }
      if (e.target.value.length == 0) {
        e.target.value = 0;
        e.key = 0;
      }
    },


    alerta(e, l) {
      if (l == "bien") {
        (this.aalert.estado = true),
          (this.aalert.color = "success"),
          (this.aalert.nombre = e);
          EventBus.$emit("loading", false);
          this.getfacturaPagarelistFactCliente()
        //  this.NewCliente();
      }

      if (l == "error") {
        (this.aalert.estado = true),
          (this.aalert.color = "error"),
          (this.aalert.nombre = e);


      }
    },


   
  },
  computed: { 
    GetEjecucion() {
      this.windowSize = JSON.parse(JSON.stringify(this.$store.getters.GetwindowSize))
     },

},
};
</script>
<style lang="scss">
</style>